import { saveAs } from 'file-saver'
import axios from 'axios'
import { ContainerComponent, Loader } from 'component'
import { module } from 'constant'

const { selector } = module.header

export const exportPdf = (exportElement: HTMLElement) => {
	const format = exportElement.getAttribute(`${selector.export.pdf.format}`)

	const exportLink = exportElement.getAttribute(`${selector.export.pdf.pdfExportLink}`)

	if (!exportLink) return
	Loader.create(ContainerComponent.getContainer('loader'), { absolute: true })

	axios({
		method: 'post',
		responseType: 'blob',
		url: exportLink,
		data: {
			format,
		},
	})
		.then((response) => {
			const fileName = 'export'
			const blob = new Blob([response.data], {
				type: format === 'screenshot' ? 'image/png' : 'application/pdf',
			})

			const extension = format === 'screenshot' ? 'png' : 'pdf'

			saveAs(URL.createObjectURL(blob), `${fileName}.${extension}`)
		})
		.finally(() => {
			Loader.destroy(ContainerComponent.getContainer('loader'))
		})
}
